interface Activities {
	name: string;
	active: string;
	setActive: (a: string) => void;
}

export const ActivityButton = (p: Activities) => {
	let className = "flex button ";
	if (p.active === p.name) {
		className = `${className} button-primary`;
	} else {
		className = `${className} button-inactive`;
	}
	return (
		<button
			type={"button"}
			className={className}
			onClick={() => p.setActive(p.name)}
		>
			{p.name}
		</button>
	);
};
